import React from 'react';
import tpl from '../templates/credit-line';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import Model from '../../../Models/credline.m';
import {apiback} from '../../../../../config';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            model: {},
            search_by: ['/business/creditline'],
            mode: 'credit-line-pledge'
        };
        this.toggleMode = this.toggleMode.bind(this);
    }

    componentWillMount() {
        document.addEventListener('switchCalcMode', this.toggleMode);
        fetch(apiback('CREDLINE_CALC'))
            .then(res => res.json())
            .then(json => {
                const list = Object.keys(json.data).reverse();
                const model = new Model(json.data, this.state.mode, list);
                this.setState({model});
            })
            .then(this.scrollToCalculator);
    }

    toggleMode(event) {
        const {mode} = event.detail;

        this.setState({mode});
        this.state.model.changeField('mode', mode);
    }

    componentWillUnmount() {
        document.removeEventListener('switchCalcMode', this.toggleMode);
    }

    scrollToCalculator = () => {
        const {pathname} = window.location;

        if (!pathname.endsWith('/calc')) return;

        this.waitForElement('.calculator-new', element => {
            element.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        });
    };

    static displayName = 'Business.Views.CreditLine';
}
